module.exports = __webpack_public_path__ + "img/close.ded70d89.svg";